import _ from "lodash";
import React from "react";
import classes from "./RightContainer.scss";
import classNames from "classnames";
import EntityCohortsDetails from "../EntityCohortsDetails";
import {
  FORWARDED_MESSAGE_LIMIT,
  FORWARD_MESSAGE_VISIBILITY_CONFIG,
} from "Platform/routes/MessagingV2/modules/Utils";
import { useI18n } from "Hooks";
import { IconButton, Alert } from "@toddle-edu/ds-web";
import { MinusCircleOutlined, ChevronUpOutlined } from "@toddle-edu/ds-icons";
import { onEnterOrSpaceKeyDown } from "Utils/AccessibilityHelpers";

const getChatAndChannels = ({ usersMap, channelsMap }) => {
  const channelsValue = _.values(channelsMap);
  const usersValue = _.values(usersMap);

  return {
    chats: usersValue,
    channels: channelsValue,
  };
};

const DetailsComp = props => {
  const { entityKey, entityData, totalCount, onExclude } = props;
  const { t } = useI18n(["common"]);
  const [open, setOpen] = React.useState(true);

  const toggleAccordion = () => setOpen(open => !open);

  const handleToggleAccordionKeyDown = e =>
    onEnterOrSpaceKeyDown(e, toggleAccordion);

  const titleText = `${t(
    FORWARD_MESSAGE_VISIBILITY_CONFIG[entityKey].header
  )} (${totalCount})`;

  const entityHeader = classNames("text-label-3", classes.entityHeader);
  return (
    <div className={classes.entityContainer}>
      <div
        className={entityHeader}
        onClick={toggleAccordion}
        role="button"
        tabIndex={0}
        onKeyDown={handleToggleAccordionKeyDown}
      >
        {titleText}
        <div
          className={classNames(classes.accordion, {
            [classes.accordionClose]: !open,
          })}
        >
          <ChevronUpOutlined />
        </div>
      </div>
      {open
        ? _.map(entityData, data => {
            const excludeKey = _.isEqual(data.type, "IND_USER")
              ? "USERS"
              : entityKey;
            return (
              <div className={classes.details} key={data.id}>
                <EntityCohortsDetails entityKey={entityKey} entityData={data} />
                <IconButton
                  variant="plain"
                  size="medium"
                  icon={<MinusCircleOutlined />}
                  onClick={() =>
                    onExclude({
                      type: excludeKey,
                      id: [data.id],
                      isChecked: true,
                    })
                  }
                />
              </div>
            );
          })
        : null}
    </div>
  );
};

const RightContainer = props => {
  const { entityDetails, onExclude = () => {} } = props;
  const { t } = useI18n(["common"]);
  const conversationSubText = classNames(
    classes.selectedSubText,
    "text-label-4"
  );

  const usersMap = _.get(entityDetails, "USERS");
  const channelsMap = _.get(entityDetails, "CHANNELS");

  const totalChatCount = _.size(usersMap);
  const totalChannelCount = _.size(channelsMap);

  const totalCount = totalChatCount + totalChannelCount;

  const containerClass = classNames(classes.container, {
    [classes.emptyContainer]: totalCount == 0,
  });
  const { chats, channels } = getChatAndChannels({
    usersMap,
    channelsMap,
  });

  return (
    <div className={containerClass}>
      <div className={classes.forwardTextClass}>
        <div className="heading-6">{t("common:forward_list")}</div>
        <div className={conversationSubText}>
          {t("common:count_conversation_selected", {
            count: totalCount,
          })}
        </div>
      </div>
      {totalCount >= FORWARDED_MESSAGE_LIMIT ? (
        <div className={classes.alertContainer}>
          <Alert
            type="warning"
            message={t("common:forward_message_max_number")}
          />
        </div>
      ) : null}

      <div className={classes.innerContainer}>
        {_.size(channels) ? (
          <DetailsComp
            entityKey={FORWARD_MESSAGE_VISIBILITY_CONFIG.CHANNELS.key}
            entityData={channels}
            totalCount={totalChannelCount}
            onExclude={onExclude}
          />
        ) : null}
        {_.size(chats) ? (
          <DetailsComp
            entityKey={FORWARD_MESSAGE_VISIBILITY_CONFIG.USERS.key}
            entityData={chats}
            totalCount={totalChatCount}
            onExclude={onExclude}
          />
        ) : null}
      </div>
    </div>
  );
};

export default RightContainer;
